import {
  enumerateYmBucketsInclusive,
  formatYmBucketLongInZone,
} from "./displayDateTime";

export type ActivityMonthOption = { value: string; label: string };

/**
 * Month picker options for trading activity calendars.
 * Covers every month from first to last activity date (inclusive), newest first.
 */
export function buildActivityMonthOptions(
  activityDateKeys: string[] | undefined,
  timeZone: string,
  fallbackMonthCount = 12
): ActivityMonthOption[] {
  const yms = (activityDateKeys || [])
    .map((d) => (d && d.length >= 7 ? d.slice(0, 7) : ""))
    .filter((ym) => /^\d{4}-\d{2}$/.test(ym))
    .sort();

  if (yms.length === 0) {
    const now = new Date();
    return Array.from({ length: fallbackMonthCount }, (_, i) => {
      const d = new Date(now.getFullYear(), now.getMonth() - i, 1);
      const value = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
      return {
        value,
        label: formatYmBucketLongInZone(value, timeZone),
      };
    });
  }

  const range = enumerateYmBucketsInclusive(yms[0], yms[yms.length - 1]);
  return range
    .slice()
    .reverse()
    .map((value) => ({
      value,
      label: formatYmBucketLongInZone(value, timeZone),
    }));
}
